import { render, staticRenderFns } from "./BoletoMobileA.vue?vue&type=template&id=462b8ab9"
import script from "./BoletoMobileA.vue?vue&type=script&lang=js"
export * from "./BoletoMobileA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports